module.exports = __webpack_public_path__ + "img/frank.aceab999.png";